import React from "react";
import { Card } from '@material-ui/core';
import CardContent from '@mui/material/CardContent';
import SchemaStars from "./schemastars";
import { formatBookingJson, manualGoogleEvents } from "../helpers/helpers";
import CallToActionDescription from "./call-to-action-description";

const ProCardsNearMe = (props) => {

    const pro = props.proData;
    const description = fixDescription(pro.d)
    const uuidv4 = require("uuid/v4")
    const randomId = pro._attributes_id + "-" + uuidv4();
    const commercialProjectType = "509";
    const cardClass = props.cardClass || 'proCardNearMe';

    function fixDescription(description){
        let desc = stripHtml(description);
        if(desc.length > 250){
            desc = desc.substring(0,250);
            desc += "... ";
        }
        return desc
    }

    function stripHtml(html) {
        let aux = html.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, ' ');
        return aux.replaceAll("&amp;", "&");
    }

    function handleCallBackAfterSubmit (formData) {
        formatBookingJson(formData);
        manualGoogleEvents('manualFormSubmition');
        if (pro.ur) {
            window.location.href = "/" + pro.ur;
        }
    }

    function addQuote (id) {
        if(props.online_booking_pros?.includes(+id) && props.code === 'dumpster'){
            return(
                <CallToActionDescription 
                    detail=""
                    startVisible={false}
                    proid={id}
                    class="get-a-quote view-prices"
                    ondeffCode='viewPricesForm'
                    btnLabel='View prices & book'
                    callBackAfterSubmit={handleCallBackAfterSubmit}
                    onlineBooking={true}
                    proUrl={"/" + pro.ur}
                />
            )
        }
        else if(props.code === 'comercial-trash-service'){
            return (
                <CallToActionDescription 
                    detail="Request pricing & availability"
                    startVisible={false}
                    proid={id}
                    initialFormData={[{ key: "pro_id", value: id }, { key: "project_type", value: commercialProjectType }]}
                    ondeffCode='commercialWasteQuoteRequest'
                    class="get-a-quote"
                />
            )
        }
        else if(props.code === 'junk-removal'){
            return (
                <CallToActionDescription 
                    detail="Request pricing & availability"
                    startVisible={false}
                    proid={id}
                    ondeffCode='junkRemovalQuoteRequest'
                    class="get-a-quote"
                />
            ) 
        }
        else if (props.code === 'dumpster'){
            return (
                <CallToActionDescription 
                    detail=""
                    startVisible={false}
                    proid={id}
                    ondeffCode='priceAndAvailabilityForm'
                    class="get-a-quote view-prices-and-availability"
                    btnLabel='Get pricing & availability'
                />
            )  
        } else {
            return (
                <CallToActionDescription 
                    detail="Request pricing & availability"
                    startVisible={false}
                    proid={id}
                    class="get-a-quote"
                    ondeffCode= 'demolitionQuoteRequest'
                />
            )
        }
    }

    return (
        <><Card className="nearMeCard" data-proid={pro._attributes_id} itemscope="itemscope" itemtype="https://schema.org/LocalBusiness" id={randomId}>
            <CardContent>
                <div data-id={pro._attributes_id} data-proid={pro._attributes_id} className={cardClass}>
                    <div className="title row">
                        <a href={"/"+pro.ur} itemprop="url"><span itemprop="name">{pro.n}</span></a>
                    </div>
                    {pro.r > 0 && <div className="reviews row">
                        <SchemaStars calculated={pro.rt && parseFloat(pro.rt).toFixed(1).toString()} url={"/"+pro.ur} reviews={pro.r}/>
                    </div>}
                    <div className="text">
                        <p itemprop="description">{description}{description.length == 254 && <a href={"/"+pro.ur}>more</a>}</p>
                    </div>
                    {addQuote(pro._attributes_id)}
                </div>
            </CardContent>
        </Card>
        </>
    )
}

export default ProCardsNearMe;